
//Mantenere coerente con variables.scss
screen_xs = 480;

screen_sm = 768;
screen_sm_min = screen_sm;

screen_md = 992;
screen_md_min = screen_md;

screen_lg = 1200;
screen_lg_min = screen_lg;

screen_xl = 1600;
screen_xl_min = screen_xl;

screen_xs_max = screen_sm_min - 1;
screen_sm_max = screen_md_min - 1;
screen_md_max = screen_lg_min - 1;


/**
 * Evento doneResizing
 * termine del ridimensionamento della finestra
 * @type type
 */
var resizeTimer;

jQuery(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        jQuery(window).trigger("doneResizing");
    }, 250);
});



/**
 * 
 * Prepara l'oggetto con le proprietà del logo da animare a seconda della larghezza del display
 * 
 * Mantenere questi valori allineati con quelli css delle pagine interne
 * 
 * @param {type} windowWidth
 * @returns {Array|Object}
 */
function dataAnimation_logo(windowWidth) {

    var dataAnimation = new Object();

    if (windowWidth > screen_xl) {

        dataAnimation = [
            new animProp('height', 'px', 200, 105),
            new animProp('margin-top', 'px', 15, 7)
        ];

    } else if (windowWidth > screen_sm) {

        dataAnimation = [
            new animProp('height', 'px', 120, 80),
            new animProp('margin-top', 'px', 10, 4)
        ];

    } else if (windowWidth < screen_sm) {

        dataAnimation = [
            new animProp('height', 'px', 90, 60),
            new animProp('margin-top', 'px', 10, 2)
        ];
    }

    return dataAnimation;
}


/**
 * Dimensionamento dinamico del logo nelle pagine interne
 * 
 * Prepara gli attributi data che verranno letti da Skrollr
 * 
 */
function setLogoSize_default() {

    logo = jQuery('#main-logo-default img');

    var windowWidth = jQuery(window).width();

    if (windowWidth > screen_xl) {
        logo.attr({
            'data-_startanchor': 'height: 170px; margin-bottom: -15px;',
            'data-_endanchor': 'height: 110px; margin-bottom: -90px;'
        });
    } else if (windowWidth > screen_sm) {
        logo.attr({
            'data-_startanchor': 'height: 16vw',
            'data-_endanchor': 'height: 8vw'
        });
    } else if (windowWidth < screen_sm) {
        logo.attr({
            'data-_startanchor': 'height: 110px',
            'data-_endanchor': 'height: 76px'
        });
    }
}


/*
 * Calcola la distanza di un elemento dal bottom al top della pagina
 * 
 * @param {type} element
 * @returns {Object.top|Integer}
 */
function getDistance_button_top(element) {

    var elementOffset = jQuery(element).offset().top;
    var outerHeight = jQuery(element).outerHeight();

    var distance = elementOffset + outerHeight;

    return distance;
}
/**
 * Come getDistance_button_top()
 * Specifico per l'elemento 'slide-highlights-wrapper'
 * avendo un altezza fissa data in css non è necessaria calcolarla al volo al load
 * 
 * @returns {Number}
 */
function getDistance_slide_highlights_wrapper() {
    var windowWidth = jQuery(window).width();

    if (windowWidth >= screen_xs_max) {
        return windowWidth * 0.57;
    } else {
        return windowWidth * 1.69;
    }
}



/**
 * Mostra l'header a seconda dello scroll
 * Utilizzato solo nel template page-homepage
 * 
 * @returns {undefined}
 */
function headerShowToggle() {
    var scroll = jQuery(window).scrollTop();

    Distance_button_top = getDistance_slide_highlights_wrapper();

    headerTarget = jQuery("#header-affix");

    if (scroll >= (Distance_button_top / 1.3)) {
        headerTarget.addClass("anim");
    } else {
        headerTarget.removeClass("anim");
    }

    if (scroll >= Distance_button_top) {
        headerTarget.addClass("show");
    } else {
        headerTarget.removeClass("show");
    }
}
/**
 * Verifica il template di pagina
 * 
 * @param {type} templateName
 * @returns {undefined}
 */
function is_template(templateName) {
    return jQuery('body').hasClass('page-template-' + templateName);
}

/**
 * COSTRUTTORE
 * Prepara l'oggetto con le proprietà da animare
 * 
 * @param {string} property
 * @param {string} unit
 * @param {integer} valueStart
 * @param {integer} valueStop
 * @returns {object}
 */
function animProp(property, unit , valueStart, valueStop) {

    unit = typeof unit !== 'undefined' ? unit : 'px';
    
    this.property = property;
    this.unit = unit;
    this.valueStart = valueStart;
    this.valueStop = valueStop;
    this.delta = valueStart - valueStop;
}
/**
 * Data una distanza in pixel dal top restituisce la percentuale di scroll relativa alla distanza
 * 
 * @param {string} distance
 * @returns {Number|percentage}
 */
function percentageOfScroll(distance) {
    scrollTop = jQuery(document).scrollTop();

    percentage = (scrollTop / distance) * 100;

    if (percentage > 100) {
        percentage = 100;
    } else if (percentage < 0) {
        percentage = 0;
    }

    return percentage;
}
/**
 * Data una distanza in pixel dal top viene settata la dimensione del logo
 * 
 * @param {string} distance
 * @param {string} windowWidth
 * @returns {undefined}
 */
function logoResize(distance, windowWidth) {
    var percentageScroll = percentageOfScroll(distance);
    var dataAnimation = dataAnimation_logo(windowWidth);

    var properties = new Object();

    dataAnimation.forEach(function (element) {
        val = element.valueStart - (percentageScroll * (element.delta) / 100);
        properties[ element.property ] = val + element.unit;
    });

    jQuery('#main-logo img').css(properties);
}




/**
 * as the page loads, call these scripts
 * 
 * @param {type} param
 */
jQuery(document).ready(function ($) {

    $("ol.commentlist a.comment-reply-link").each(function () {
        $(this).addClass('btn btn-success btn-mini');
        return true;
    });

    $('#cancel-comment-reply-link').each(function () {
        $(this).addClass('btn btn-danger btn-mini');
        return true;
    });

    // Prevent submission of empty form
    $('[placeholder]').parents('form').submit(function () {
        $(this).find('[placeholder]').each(function () {
            var input = $(this);
            if (input.val() === input.attr('placeholder')) {
                input.val('');
            }
        });
    });

    $('.alert-message').alert();

    $('.dropdown-toggle').dropdown();

    $('.tooltip-top').tooltip({
        container: 'body'
    });

    $('#mainHeader').infinitewalker();





    $('.slide-highlights').slick({
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
//        prevArrow: '#prev',
//        nextArrow: '#next',
        autoplay: true,
        autoplaySpeed: 4000
//        responsive: [
//            {
//                breakpoint: 1300,
//                settings: {
//                    slidesToShow: 3,
//                    slidesToScroll: 1
//                }
//            },
//            {
//                breakpoint: 980,
//                settings: {
//                    centerMode: false,
//                    slidesToShow: 1,
//                    slidesToScroll: 1
//                }
//            }
//        ]
    });




    $(".toggle-menu").click(function () {
        $('body').addClass('nav-sidebar-right-swow');
        $("body").append("<div class='nav-sidebar-backdrop fade'></div>");

        setTimeout(function () {
            $('.nav-sidebar-backdrop').addClass('in');
        }, 10);

        $(".nav-sidebar-backdrop , #main-nav-btn-close").click(function () {
            $('body').removeClass('nav-sidebar-right-swow');

            $('.nav-sidebar-backdrop').removeClass('in');
            setTimeout(function () {
                $(".nav-sidebar-backdrop").remove();
            }, 150);
        });
    });


    $(".open-tag-more a ").click(function (event) {
        event.preventDefault();
        $(".menu-menu-tag-more-container").slideDown();
    });




    if (is_template('page-homepage')) {

        var windowWidth = $(window).width();
        var distance = getDistance_slide_highlights_wrapper();

        /**
         * header affix in home
         */
        $('#header-affix').affix({
            offset: {
                top: function () {
                    return getDistance_button_top('#header-affix-wrapper');
                }
            }
        });
        /**
         * Mostra l'header dopo aves scrollato
         */
        headerShowToggle();



        logoResize(distance, windowWidth);


        /**
         * ON Resize
         */
        $(window).resize(function () {
            // lascia queste variabili globali
            // vanno passate all'evento scroll
            windowWidth = $(window).width();
            distance = getDistance_slide_highlights_wrapper();

            logoResize(distance, windowWidth);
        });

        /**
         * ON Scroll
         */
        $(window).scroll(function () {
            logoResize(distance, windowWidth);

            headerShowToggle();
        });
    }




    /**
     * Ricerca
     */
    $(".toggle-search").click(function () {
        $('#modal-search').modal();
    });

    $('#modal-search').on('show.bs.modal', function (event) {
        $('.toggle-search.ghost-menu , .toggle-menu.ghost-menu').addClass('ghost-menu-hidden');
    });
    $('#modal-search').on('shown.bs.modal', function (event) {
        $('#modal-search-form-input').focus();
    });
    $('#modal-search').on('hide.bs.modal', function (event) {
        $('.toggle-search.ghost-menu , .toggle-menu.ghost-menu').removeClass('ghost-menu-hidden');
    });





    /**
     * ON load
     */
    $(window).load(function () {

    });

    /**
     * ON Resize
     */
    $(window).resize(function () {
    });

    /**
     * ON Scroll
     */
    $(window).scroll(function () {
    });


});

